module.exports = __webpack_public_path__ + "img/blog-3-2.2302dfb7.webp";